import React from 'react';
import Joyas from 'componentsPrestamo/Prestamos/Joyeria'

const CrearProceso = () => {
    return ( 
        <Joyas/>
     );
}
 
export default CrearProceso;